import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, Outlet } from 'react-router-dom';
import Login from '../pages/Login';
import Home from '../pages/Home';
import PrivateRoute from '../components/PrivateRoute';
import Register from '../pages/Register';
import RegisterData from '../pages/RegisterData';
import Negocio from '../pages/Negocio';
import AuthCallback from '../pages/AuthCallback';
import Reauth from '../pages/Reauth';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import OperatorAuthCallback from '../pages/OperatorAuthCallback';
import EmailLinkHandler from '../components/EmailLinkHandler';
import Bienvenida from '../pages/Bienvenida';
import RegistroError from '../pages/RegistroError';
import TestModal from '../pages/TestModal';
import DevLogin from '../pages/DevLogin';
import TutorialOperadores from '../pages/TutorialOperadores';
import { getAuth } from 'firebase/auth';
import { initializeFirebase } from '../firebase/config';
import metaPixelService from '../services/metaPixelService';
import { META_PIXEL_CONFIG, shouldTrackPage, CUSTOM_EVENTS } from '../config/metaPixelConfig';

// Componente para manejar Meta Pixel y tracking de UTM
function MetaPixelTracker() {
    const location = useLocation();

    useEffect(() => {
        try {
            // Capturar parámetros UTM al cargar la primera página
            const urlParams = new URLSearchParams(location.search);
            const hasUtmParams = urlParams.has('utm_source') || urlParams.has('utm_campaign') || urlParams.has('fbclid');

            if (hasUtmParams) {
                console.log('Parámetros UTM detectados:', {
                    utm_source: urlParams.get('utm_source'),
                    utm_campaign: urlParams.get('utm_campaign'),
                    utm_medium: urlParams.get('utm_medium'),
                    utm_content: urlParams.get('utm_content'),
                    utm_term: urlParams.get('utm_term'),
                    fbclid: urlParams.get('fbclid')
                });

                // Los parámetros UTM ya se capturan automáticamente en el constructor del servicio
                // pero aquí podemos añadir lógica adicional si es necesario
            }

            // Trackear evento personalizado para cambios de página en rutas específicas
            const pageName = location.pathname.split('/').filter(Boolean).join('/') || 'home';

            if (shouldTrackPage(location.pathname)) {
                metaPixelService.trackCustomEvent(CUSTOM_EVENTS.PAGE_VIEW, {
                    page_name: pageName,
                    page_url: location.pathname + location.search,
                    referrer: document.referrer
                });
            }

        } catch (error) {
            console.error('Error en MetaPixelTracker:', error);
            // No lanzar el error para evitar que la aplicación se rompa
        }
    }, [location]);

    return null;
}

// Componente que envuelve la aplicación y proporciona el seguimiento de Analytics
function AppContent() {
    // Inicializar Firebase al montar el componente
    useEffect(() => {
        initializeFirebase().catch(console.error);
    }, []);

    return (
        <>
            {/* Componente que maneja los enlaces de autenticación por email */}
            <EmailLinkHandler />

            {/* Componente para manejar Meta Pixel y tracking de UTM */}
            <MetaPixelTracker />

            <Routes>
                <Route path="/login" element={<Login />} />
                {/* Ruta de desarrollo - solo accesible en localhost */}
                {process.env.NODE_ENV === 'development' && (
                    <Route path="/dev-login" element={<DevLogin />} />
                )}
                {process.env.NODE_ENV === 'development' && (
                    <Route path="/tutorial-operadores" element={<TutorialOperadores />} />
                )}
                <Route
                    path="/home"
                    element={
                        <PrivateRoute>
                            <Home />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/"
                    element={<Navigate to="/home" replace />}
                />
                <Route path="/registro" element={<RegisterData />} />
                <Route path="/registro/datos" element={<Register />} />
                <Route path="/registro/negocio" element={<Negocio />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/reauth" element={<Reauth />} />
                <Route path="/__/auth/action" element={<OperatorAuthCallback />} />
                <Route path="/recuperar-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/bienvenida" element={<Bienvenida />} />
                <Route path="/registro-error" element={<RegistroError />} />
                <Route path="/test-modal" element={<TestModal />} />
            </Routes>
        </>
    );
}

function AppRouter() {
    return (
        <BrowserRouter>
            <AppContent />
        </BrowserRouter>
    );
}

export default AppRouter;
